<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <h1 class="hero-title">
          {{ locale === 'zh' ? '联系我们' : locale === 'en' ? 'Contact Us' : 'Hubungi Kami' }}
        </h1>
        <p class="hero-description">
          {{ locale === 'zh' ? '期待与你的相遇' : locale === 'en' ? 'Looking forward to meeting you' : 'Menunggu untuk bertemu dengan Anda' }}
        </p>
      </div>
      <img class="hero-image" src="https://www-img.sanfu.com/production/sort-icons2.png" alt="" />
    </section>

    <!-- Contact Info -->
    <section class="contact-section">
      <div class="contact-grid">
        <!-- Contact Info -->
        <div class="contact-info">
          <h2 class="info-title">
            {{ locale === 'zh' ? '联系信息' : locale === 'en' ? 'Contact Information' : 'Informasi Kontak' }}
          </h2>

          <div class="info-cards">
            <div class="info-card" v-for="info in contactInfo" :key="info.type">
              <div class="info-icon" :style="{ backgroundColor: info.color }">
                <svg v-if="info.type === 'phone'" class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25z" />
                </svg>
                <svg v-else-if="info.type === 'email'" class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67z" />
                  <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908z" />
                </svg>
                <svg v-if="info.type === 'address'" class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742zM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="info-content">
                <h3 class="info-label">{{ info.label[locale] }}</h3>
                <p class="info-value">{{ info.value[locale] }}</p>
                <p v-if="info.extra" class="info-extra">{{ info.extra[locale] }}</p>
              </div>
            </div>
          </div>

          <!-- Social Media -->
          <div class="social-section">
            <h3 class="info-title">
              {{ locale === 'zh' ? '关注我们' : locale === 'en' ? 'Follow Us' : 'Ikuti Kami' }}
            </h3>
            <div class="social-links">
              <a target="blank" href="https://www.xiaohongshu.com/user/profile/5ab8ad39e8ac2b58e1d6b352" class="social-link" :aria-label="socialLabels.xiaohongshu[locale]">
                <img class="social-icon" :alt="socialLabels.xiaohongshu[locale]" src="https://www-img.sanfu.com/production/xiaohongshu.png" />
              </a>
              <a target="blank" href="https://weibo.com/u/1738393562" class="social-link" :aria-label="socialLabels.weibo[locale]">
                <img class="social-icon" :alt="socialLabels.weibo[locale]" src="https://www-img.sanfu.com/production/weibo.png" />
              </a>
              <a target="blank" href="https://www.douyin.com/user/MS4wLjABAAAAsonBW_lf-29tzoop3oodVS3eRWWD863Sl5ErJQ9S_7Q" class="social-link" :aria-label="socialLabels.douyin[locale]">
                <img class="social-icon" :alt="socialLabels.douyin[locale]" src="https://www-img.sanfu.com/production/douyin.png" />
              </a>
              <a target="blank" href="https://v.kuaishou.com/f/Y7TQR7XG1" class="social-link" :aria-label="socialLabels.kuaishou[locale]">
                <img class="social-icon" :alt="socialLabels.kuaishou[locale]" src="https://www-img.sanfu.com/production/kuaishou.png" />
              </a>
              <a target="blank" href="http://space.bilibili.com/213697595" class="social-link" :aria-label="socialLabels.bilibili[locale]">
                <img class="social-icon" :alt="socialLabels.bilibili[locale]" src="https://www-img.sanfu.com/production/bilibili.png" />
              </a>
              <a target="blank" href="https://sffs.tmall.com/" class="social-link" :aria-label="socialLabels.tmall[locale]">
                <img class="social-icon" :alt="socialLabels.tmall[locale]" src="https://www-img.sanfu.com/production/tmall.png" />
              </a>
              <a target="blank" href="https://m.sanfu.com" class="social-link" :aria-label="socialLabels.mall[locale]">
                <img class="social-icon" :alt="socialLabels.mall[locale]" src="https://www-img.sanfu.com/production/logo2.png" />
              </a>
            </div>
          </div>

          <!-- WeChat QR Codes -->
          <div class="wechat-section">
            <h3 class="info-title">
              {{ locale === 'zh' ? '微信公众号' : locale === 'en' ? 'WeChat Official Accounts' : 'Akun Resmi WeChat' }}
            </h3>
            <div class="wechat-codes">
              <div class="wechat-code">
                <img src="https://www-img.sanfu.com/production/wechat1.jpg" :alt="wechatLabels.service[locale]" class="qr-code-image" />
                <div class="wechat-text">{{ wechatLabels.service[locale] }}</div>
              </div>
              <div class="wechat-code">
                <img src="https://www-img.sanfu.com/production/wechat_subscribe.jpg" :alt="wechatLabels.subscription[locale]" class="qr-code-image" />
                <div class="wechat-text">{{ wechatLabels.subscription[locale] }}</div>
              </div>
              <div class="wechat-code">
                <img src="https://www-img.sanfu.com/production/wechat_sph.jpg" :alt="wechatLabels.videoChannel[locale]" class="qr-code-image" />
                <div class="wechat-text">{{ wechatLabels.videoChannel[locale] }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="faq-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">
            {{ locale === 'zh' ? '常见问题' : locale === 'en' ? 'Frequently Asked Questions' : 'Pertanyaan yang Sering Diajukan' }}
          </h2>
          <p class="section-description">
            {{ locale === 'zh' ? '查看我们最常被问到的问题和答案' : locale === 'en' ? 'Check out our most frequently asked questions and answers' : 'Lihat pertanyaan dan jawaban yang paling sering diajukan' }}
          </p>
        </div>

        <div class="faq-list">
          <div v-for="(faq, index) in faqs" :key="index" class="faq-item" :class="{ active: activeFaq === index }">
            <div class="faq-question" @click="toggleFaq(index)">
              <span>{{ faq.question[locale] }}</span>
              <svg class="faq-icon" :class="{ rotated: activeFaq === index }" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="faq-answer" v-if="activeFaq === index">
              <p>{{ faq.answer[locale] }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
  import { ref } from 'vue'

  useHead({
    title: '联系我们 - SANFU',
    meta: [{ name: 'description', content: '联系我们获取更多信息，我们随时为您提供帮助和支持' }]
  })

  const { locale } = useI18n()
  const activeFaq = ref(null)

  const contactInfo = ref([
    {
      type: 'address',
      color: 'var(--brand-red)',
      label: { zh: '地址', en: 'Address', id: 'Alamat' },
      value: { zh: '中国福建省福州市鼓楼区', en: 'Gulou District, Fuzhou City, Fujian Province, China', id: 'Gulou District, Fuzhou City, Fujian Province, Tiongkok' },
      extra: { zh: '省府路1号省府大院金皇大厦9楼西0901', en: 'Jinhuang Building, 9th Floor West, No. 1 Shengfu Road, Gulou District, Fuzhou, Fujian, China', id: 'Gedung Jinhuang, Lantai 9 Barat, No. 1 Jalan Shengfu, Distrik Gulou, Kota Fuzhou, Provinsi Fujian, Tiongkok' }
    },
    {
      type: 'phone',
      color: 'var(--brand-orange)',
      label: { zh: '电话', en: 'Phone', id: 'Telepon' },
      value: { zh: '400-111-1992', en: '+86 400-111-1992', id: '+86 400-111-1992' }
    },
    // {
    //   type: 'email',
    //   color: 'var(--brand-blue)',
    //   label: { zh: '邮箱', en: 'Email', id: 'Email' },
    //   value: { zh: 'sanfubrand@163.com', en: 'csanfubrand@163.com', id: 'sanfubrand@163.com' }
    // }
  ])

  const socialLabels = ref({
    xiaohongshu: { zh: '小红书', en: 'Xiaohongshu', id: 'Xiaohongshu' },
    weibo: { zh: '微博', en: 'Weibo', id: 'Weibo' },
    douyin: { zh: '抖音', en: 'Douyin', id: 'Douyin' },
    kuaishou: { zh: '快手', en: 'Kuaishou', id: 'Kuaishou' },
    bilibili: { zh: '哔哩哔哩', en: 'Bilibili', id: 'Bilibili' },
    tmall: { zh: '天猫', en: 'Tmall', id: 'Tmall' },
    mall: { zh: '商城', en: 'Mall', id: 'Mall' }
  })

  const wechatLabels = ref({
    service: { zh: '服务号', en: 'Service Account', id: 'Akun Layanan' },
    subscription: { zh: '订阅号', en: 'Subscription Account', id: 'Akun Berlangganan' },
    videoChannel: { zh: '视频号', en: 'Video Channel', id: 'Saluran Video' }
  })

  const faqs = ref([
    {
      question: { zh: '如何联系客服？', en: 'How to contact customer service?', id: 'Bagaimana menghubungi layanan pelanggan?' },
      answer: { zh: '您可以通过电话、邮箱联系我们，我们的客服团队会及时为您提供帮助。', en: 'You can contact us by phone, email or online form, our customer service team will help you promptly.', id: 'Anda dapat menghubungi kami melalui telepon, email atau formulir online, tim layanan pelanggan kami akan membantu Anda dengan segera.' }
    }
    // {
    //   question: { zh: '产品质保期是多久？', en: 'What is the product warranty period?', id: 'Berapa lama periode garansi produk?' },
    //   answer: { zh: '我们的产品提供1-3年不等的质保期，具体时长根据产品类型而定。详细信息请查看产品说明书。', en: 'Our products come with a warranty period of 1-3 years, depending on the product type. Please check the product manual for details.', id: 'Produk kami dilengkapi dengan periode garansi 1-3 tahun, tergantung pada jenis produk. Silakan periksa manual produk untuk detailnya.' }
    // },
    // {
    //   question: { zh: '是否支持国际配送？', en: 'Do you support international shipping?', id: 'Apakah Anda mendukung pengiriman internasional?' },
    //   answer: { zh: '是的，我们支持全球配送服务。配送时间和费用根据目的地而有所不同，详情请咨询客服。', en: 'Yes, we support global shipping services. Delivery time and cost vary depending on the destination, please consult customer service for details.', id: 'Ya, kami mendukung layanan pengiriman global. Waktu pengiriman dan biaya bervariasi tergantung pada tujuan, silakan konsultasikan dengan layanan pelanggan untuk detailnya.' }
    // }
  ])

  const toggleFaq = index => {
    activeFaq.value = activeFaq.value === index ? null : index
  }
</script>

<style scoped>
  .hero {
    /* margin-top: -70px; */
    padding: var(--space-10) 0 var(--space-2);
    background: linear-gradient(0deg, var(--gray-100) 0%, var(--white) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  .hero-content {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
  }

  .hero-title {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: var(--space-2);
    /* color: #fff; */
    letter-spacing: 1px;
  }

  .hero-description {
    font-size: 20px;
    line-height: 1.6;
    opacity: 0.85;
    /* color: #fff; */
  }

  .hero-image {
    width: 80%;
    min-width: 400px;
    max-width: 1000px;
    max-height: 80px;
    object-fit: contain;
    margin: 15px 0;
  }

  .contact-section {
    padding: var(--space-4) 0;
  }

  .contact-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--space-12);
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
  }

  .contact-info {
    padding: var(--space-8);
  }

  .info-title {
    font-size: var(--text-2xl);
    font-weight: 600;
    margin-bottom: var(--space-8);
    color: var(--gray-900);
    text-align: center;
    cursor: default;
    user-select: none;
  }

  .info-cards {
    margin: 0 auto;
    margin-bottom: var(--space-10);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-6);
  }

  .info-card {
    width: 100%;
    display: flex;
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-6);
    background-color: var(--white);
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow);
    transition: transform var(--transition-fast), box-shadow var(--transition-fast);
  }

  .info-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }

  .info-icon {
    width: 60px;
    height: 60px;
    border-radius: var(--radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white);
    flex-shrink: 0;
  }

  .info-content {
    flex: 1;
  }

  .info-label {
    font-weight: 600;
    margin-bottom: var(--space-2);
    color: var(--gray-900);
    font-size: var(--text-lg);
  }

  .info-value {
    color: var(--gray-700);
    margin-bottom: var(--space-1);
    font-size: var(--text-base);
  }

  .info-extra {
    font-size: var(--text-sm);
    color: var(--gray-500);
    margin-bottom: 0;
  }

  .social-section {
    margin-bottom: var(--space-10);
    background-color: var(--white);
  }

  .social-links {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: var(--space-4);
    padding: var(--space-6);
    box-shadow: var(--shadow);
    border-radius: var(--radius-xl);
  }

  .social-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-4);
    background-color: var(--gray-50);
    border-radius: var(--radius-lg);
    color: var(--gray-700);
    text-decoration: none;
    transition: all var(--transition-fast);
    text-align: center;
  }

  .social-link:hover {
    background-color: var(--primary);
    color: var(--white);
    transform: translateY(-3px);
    box-shadow: var(--shadow-md);
  }

  .social-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: var(--radius);
  }

  .wechat-section {
    background-color: var(--white);
  }

  .wechat-codes {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--space-6);
    justify-items: center;
    border-radius: var(--radius-xl);
    padding: var(--space-6);
    box-shadow: var(--shadow);
  }

  .wechat-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-3);
  }

  .qr-code-image {
    width: 150px;
    height: 150px;
    border-radius: var(--radius);
    box-shadow: var(--shadow-sm);
    transition: transform var(--transition-fast);
  }

  .qr-code-image:hover {
    transform: scale(1.05);
  }

  .wechat-text {
    font-weight: 500;
    color: var(--gray-700);
    text-align: center;
  }

  .faq-section {
    padding: var(--space-20) 0;
    background-color: var(--gray-50);
  }

  .section-header {
    text-align: center;
    margin-bottom: var(--space-12);
  }

  .section-title {
    font-size: var(--text-3xl);
    font-weight: 600;
    margin-bottom: var(--space-4);
    color: var(--gray-900);
  }

  .section-description {
    font-size: var(--text-lg);
    color: var(--gray-600);
    max-width: 600px;
    margin: 0 auto;
  }

  .faq-list {
    max-width: 800px;
    margin: 0 auto;
  }

  .faq-item {
    background-color: var(--white);
    border-radius: var(--radius-lg);
    margin-bottom: var(--space-4);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    transition: box-shadow var(--transition-fast);
  }

  .faq-item:hover {
    box-shadow: var(--shadow);
  }

  .faq-question {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--space-4) var(--space-6);
    background: none;
    border: none;
    font-size: var(--text-lg);
    font-weight: 500;
    color: var(--gray-900);
    cursor: pointer;
    transition: background-color var(--transition-fast);
  }

  .faq-question:hover {
    background-color: var(--gray-50);
  }

  .faq-icon {
    width: 20px;
    height: 20px;
    transition: transform var(--transition-fast);
  }

  .faq-icon.rotated {
    transform: rotate(180deg);
  }

  .faq-answer {
    padding: 0 var(--space-6) var(--space-4);
    color: var(--gray-600);
    line-height: 1.6;
    animation: fadeIn var(--transition-base) ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    .hero-title {
      font-size: var(--text-3xl);
    }
    .hero-description {
      font-size: 16px;
    }
    .info-cards {
      grid-template-columns: 1fr;
    }

    .social-links {
      grid-template-columns: repeat(2, 1fr);
      padding: var(--space-4);
    }

    .wechat-codes {
      grid-template-columns: 1fr;
    }

    .hours-item {
      flex-direction: column;
      text-align: center;
      gap: var(--space-1);
    }

    .wechat-codes {
      padding: var(--space-4);
      grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    }

    .qr-code-image {
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 480px) {
    .contact-info {
      padding: var(--space-4);
    }
  }

  .contact-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #fff;
  }
</style>
